import React from 'react';
import PropTypes from 'prop-types';
import {
  Rate, Select, Spin, Tag,
} from 'antd';
import { Flex, ShowIf, Text } from '../../../shared/components';
import TratamientosCheckBoxs from '../bars/TratamientosCheckBoxs';
import DiametrosSelection from '../bars/DiametrosSelection';
import {
  obtenerDescripcionLenteCompletaSinSuplementos,
} from '../../../../helpers/modules/pel.helper';
import AlturaFocaInput from '../bars/AlturaFocalInput';
import { ERROR_ALTURA_FOCAL } from '../../model/constants/erroresSeleccionLente.constants';
import {autoFormatCurrency} from "../../../../helpers/common.helper";

export function calcularPreciosLentesPorOjos(modoNoPel, trabajaConColores, selectedTratamiento, colorSeleccionado, graduacionDerechaSeleccionada, graduacionIzquierdaSeleccionada) {
  const tienePrecioIzquierdoDistinto = selectedTratamiento.precio_oi !== undefined && selectedTratamiento.precio_oi !== selectedTratamiento.precio;
  const tieneDosLentes = graduacionDerechaSeleccionada && graduacionIzquierdaSeleccionada;
  const sumarColorYTratamiento = (modoNoPel || !trabajaConColores) && colorSeleccionado && colorSeleccionado.pvp;
  let precio = sumarColorYTratamiento ? selectedTratamiento.precio + parseFloat(colorSeleccionado.pvp) : selectedTratamiento.precio;
  let precioSubLabel = '';
  let precio_oi = null;
  if (tienePrecioIzquierdoDistinto) {
    precio_oi = sumarColorYTratamiento ? selectedTratamiento.precio_oi + parseFloat(colorSeleccionado.pvp) : selectedTratamiento.precio_oi;
    if (tieneDosLentes) {
      precioSubLabel = `${autoFormatCurrency(precio)} + ${autoFormatCurrency(precio_oi)}`;
      precio += precio_oi;
    } else if (graduacionDerechaSeleccionada) {
      precioSubLabel = '';
    } else if (graduacionIzquierdaSeleccionada) {
      precioSubLabel = '';
      precio = precio_oi;
    }
  } else {
    precioSubLabel = tieneDosLentes ? `2 lentes x ${autoFormatCurrency(precio)}` : '';
    precio = tieneDosLentes ? precio * 2 : precio;
  }
  return { precio, precioSubLabel };
}

export default function LenteListElement({
  lente: {
    key, nombreCompleto, tratamientos, isSelected, diametros, diametrosSeleccionados, colores, favoritoIdLente,
  }, expanded, setSelecccionTratamientoLente, seleccionarColorIntensidad, drawColoracion, errorSeleccion,
  graduaciones, pasillo, miColor, gamasColoresOpciones, selectedGamaColor, trabajaConColores, alturaFocalObligatoria,
  modo, modoNoPel, setSelecccionDiametroLente, loadingColoresLente, loadingDiametrosLente, onAlturaFocalChange, loadingTratamientosLente,
}) {
  const lenteFavorita = favoritoIdLente && favoritoIdLente > 1;
  const selectedTratamiento = tratamientos.find(({ isSelected }) => isSelected);
  const { tieneRestriccionPrecio } = selectedTratamiento;
  const graduacionDerechaSeleccionada = graduaciones.derecho && graduaciones.derecho.isSelected;
  const graduacionIzquierdaSeleccionada = graduaciones.izquierdo && graduaciones.izquierdo.isSelected;
  const tieneAlMenosUnaGraduacionSeleccionada = graduacionDerechaSeleccionada || graduacionIzquierdaSeleccionada;
  const mostrarDiametros = !tieneRestriccionPrecio && (tieneAlMenosUnaGraduacionSeleccionada || modo === 'consulta');
  const colorSeleccionado = colores.find(e => e.isSelected);
  const { precio, precioSubLabel } = calcularPreciosLentesPorOjos(modoNoPel, trabajaConColores, selectedTratamiento, colorSeleccionado, graduacionDerechaSeleccionada, graduacionIzquierdaSeleccionada);
  const descripcionLinea = obtenerDescripcionLenteCompletaSinSuplementos(modoNoPel, nombreCompleto, { miColor, gamaColor: selectedGamaColor, gamasColoresOpciones }, pasillo);
  const drawColoracionSelect = !tieneRestriccionPrecio && (drawColoracion && colores.length > 0 && colores[0].nombre !== '' && (colores.length !== 1 || colores[0].id !== -1) && (!colores[0].tipoId || (colores[0].tipoId && colores[0].tipoId !== 0)));
  const drawColoresOptions = colores => (
    colores.map(({ id, nombre, pvp }) => (
      <Select.Option value={id}>
        {(id !== -1 && (modoNoPel || !trabajaConColores)) && (pvp ? `${nombre} (+${autoFormatCurrency(pvp)})` : `${nombre} (sin coste)`)}
        {(id === -1 && (modoNoPel || !trabajaConColores)) && (pvp ? `${nombre} (+${autoFormatCurrency(pvp)})` : `${nombre}`)}
        {(!modoNoPel && trabajaConColores) && (`${nombre}`)}
      </Select.Option>
    ))
  );
  const errorAlturaFocal = errorSeleccion && errorSeleccion.lenteKey === key && errorSeleccion.element === ERROR_ALTURA_FOCAL ? errorSeleccion : null;
  const errorAlturaFocalDerecha = errorAlturaFocal && (!errorAlturaFocal.errorData || errorAlturaFocal.errorData.ojo === 'derecho');
  const errorAlturaFocalIzquierda = errorAlturaFocal && (!errorAlturaFocal.errorData || errorAlturaFocal.errorData.ojo === 'izquierdo');
  return (
    <Flex justifyContent="space-between" py={16} alignItems="baseline" width="100%">
      <Flex flexDirection="column" width="100%">
        <Flex alignItems="baseline" justifyContent="space-between">
          <Flex alignItems="baseline">
            <ShowIf condition={lenteFavorita}><Rate count={1} disabled defaultValue={2} /></ShowIf>
            <Tag style={{ padding: '2px 7px 0 7px', marginLeft: '8px' }} color={(selectedTratamiento.esRX) ? 'orange' : 'green'}>{(selectedTratamiento.esRX) ? 'RX' : 'ST'}</Tag>
            <Text fontWeight={isSelected ? 600 : 400}>
              {descripcionLinea.toUpperCase()}
            </Text>
          </Flex>
          <Flex alignItems="baseline" mr="8px">
            <TratamientosCheckBoxs
              loading={modoNoPel && isSelected && loadingTratamientosLente.running}
              tratamientos={tratamientos}
              disabled={!expanded}
              modoNoPel={modoNoPel}
              tratamientoSeleccionado={selectedTratamiento}
              handleChangeTratamientos={tratamientoId => setSelecccionTratamientoLente(key, tratamientoId)}
            />
            <Text width={80} ml={16} textAlign="end" fontWeight={isSelected ? 600 : 400}>
              {selectedTratamiento !== undefined ? autoFormatCurrency(precio, {addWhiteSpace:true}) : 'Sin precio'}
            </Text>
          </Flex>
        </Flex>
        { (isSelected && expanded && (loadingColoresLente.running || loadingDiametrosLente.running)) && (
          <Spin />
        )}
        {expanded && (!loadingColoresLente.running && !loadingDiametrosLente.running) && (
        <Flex mt={8} justifyContent="space-between" alignItems="baseline">
          <Flex alignItems="baseline" ml="8px">
            { (drawColoracionSelect && !loadingColoresLente.running) && (
            <Flex alignItems="center">
              Color:
              <Select
                value={colorSeleccionado ? colorSeleccionado.id : null}
                size="small"
                style={{
                  minWidth: modoNoPel ? 300 : 220, borderColor: 'transparent', marginLeft: '8px', marginRight: '16px',
                }}
                onChange={colorIntensidadId => seleccionarColorIntensidad(key, colorIntensidadId)}
              >
                {drawColoresOptions(colores)}
              </Select>
            </Flex>
            )}
            {mostrarDiametros && !loadingDiametrosLente.running
            && (
              <Flex alignItems="center" flexDirection="column">
                <Flex alignItems="center">
                  Dia.
                  <DiametrosSelection
                    label="D"
                    diametro={diametrosSeleccionados ? diametrosSeleccionados.D : null}
                    diametros={/* modoNoPel && */ diametros ? diametros.D : selectedTratamiento.diametros.D}
                    hide={!graduacionDerechaSeleccionada}
                    disabled={/* !modoNoPel */ false}
                    setSelecccionDiametroLente={diametro => setSelecccionDiametroLente(key, { ojo: 'D', diametro })}
                  />
                  <DiametrosSelection
                    diametro={diametrosSeleccionados ? diametrosSeleccionados.D : null}
                    diametros={/* modoNoPel && */ diametros ? diametros.D : selectedTratamiento.diametros.D}
                    hide={modo !== 'consulta'}
                    disabled={/* !modoNoPel */ false}
                    setSelecccionDiametroLente={diametro => setSelecccionDiametroLente(key, { ojo: 'B', diametro })}
                  />
                  <DiametrosSelection
                    label="I"
                    diametro={diametrosSeleccionados ? diametrosSeleccionados.I : null}
                    diametros={/* modoNoPel && */ diametros ? diametros.I : selectedTratamiento.diametros.I}
                    hide={!graduacionIzquierdaSeleccionada}
                    disabled={/* !modoNoPel */ false}
                    setSelecccionDiametroLente={diametro => setSelecccionDiametroLente(key, { ojo: 'I', diametro })}
                  />
                </Flex>
                <Flex ml="8px" h="17px" />
              </Flex>
            )
            }
            {!tieneRestriccionPrecio && alturaFocalObligatoria && modo !== 'consulta'
            && (
              <Flex marginLeft="16px" flexDirection="column">
                <Flex alignItems="center" h="22px">
                  Alt. Focal:
                  <AlturaFocaInput
                    label="D"
                    mostrarError={errorAlturaFocalDerecha}
                    hide={!graduacionDerechaSeleccionada}
                    onChange={altura => onAlturaFocalChange(key, { ojo: 'D', altura })}
                  />
                  <AlturaFocaInput
                    label="I"
                    mostrarError={errorAlturaFocalIzquierda}
                    hide={!graduacionIzquierdaSeleccionada}
                    onChange={altura => onAlturaFocalChange(key, { ojo: 'I', altura })}
                  />
                </Flex>
                <Flex ml="79px" h="17px" flexDirection="row">
                  { errorAlturaFocalDerecha && (<Text width="94px" color="red" fontSize="12px" pl="10px" lineHeight="17px">Obligatorio</Text>)}
                  { errorAlturaFocalIzquierda && (<Text width="94px" color="red" fontSize="12px" pl="10px" lineHeight="17px">Obligatorio</Text>)}
                </Flex>
              </Flex>
            )
           }
            {tieneRestriccionPrecio && (
              <Text lineHeight="22px" marginLeft="38px" opacity="0.5">(No disponible)</Text>
            )}

          </Flex>
          <Flex justifyContent="flex-end" alignItems="flex-start" mr="8px">
            <Text color={tieneRestriccionPrecio ? '#DD0426' : '#706E6B'} fontSize={tieneRestriccionPrecio ? 14 : 12} lineHeight={tieneRestriccionPrecio ? '22px' : '12px'}>
              {tieneRestriccionPrecio ? 'Tratamiento no disponible debido a las restricciones de la promocion' : precioSubLabel}
            </Text>
          </Flex>
        </Flex>
        )}
      </Flex>
    </Flex>
  );
}
LenteListElement.propTypes = {
  modo: PropTypes.string.isRequired,
  miColor: PropTypes.shape({ id: PropTypes.number, gamaColor: PropTypes.number, nombre: PropTypes.string }),
  lente: PropTypes.shape({
    key: PropTypes.string,
    nombreCompleto: PropTypes.string,
    isSelected: PropTypes.bool,
    tratamientos: PropTypes.arrayOf(PropTypes.shape({ isSelected: PropTypes.bool })),
    colores: PropTypes.arrayOf(PropTypes.shape({ isSelected: PropTypes.bool })),
    diametros: PropTypes.shape({
      D: PropTypes.arrayOf(PropTypes.number),
      I: PropTypes.arrayOf(PropTypes.number),
    }),
    diametrosSeleccionados: PropTypes.shape({
      D: PropTypes.number,
      I: PropTypes.number,
    }),
  }).isRequired,
  graduaciones: PropTypes.shape({
    izquierdo: PropTypes.shape({
      isSelected: PropTypes.bool,
    }),
    derecho: PropTypes.shape({
      isSelected: PropTypes.bool,
    }),
  }).isRequired,
  expanded: PropTypes.bool,
  drawColoracion: PropTypes.bool,
  modoNoPel: PropTypes.bool,
  alturaFocalObligatoria: PropTypes.bool,
  setSelecccionTratamientoLente: PropTypes.func,
  seleccionarColorIntensidad: PropTypes.func,
  onAlturaFocalChange: PropTypes.func,
  setSelecccionDiametroLente: PropTypes.func,
  pasillo: PropTypes.shape({
    id: PropTypes.number,
    isSelected: PropTypes.bool,
  }),
  gamasColoresOpciones: PropTypes.arrayOf(PropTypes.shape({})),
  selectedGamaColor: PropTypes.shape({ gama_color: PropTypes.string }),
  loadingColoresLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingDiametrosLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
};
LenteListElement.defaultProps = {
  expanded: false,
  drawColoracion: false,
  alturaFocalObligatoria: false,
  modoNoPel: false,
  setSelecccionTratamientoLente: () => {},
  seleccionarColorIntensidad: () => {},
  setSelecccionDiametroLente: () => {},
  onAlturaFocalChange: () => {},
  loadingColoresLente: { running: false, success: false },
  loadingDiametrosLente: { running: false, success: false },
  pasillo: { id: 0 },
  gamasColoresOpciones: [],
  miColor: null,
  selectedGamaColor: null,
  tratamientoSeleccionado: null,
};
